import {
    Airplay,
    Image as ImageIcon,
    User,
    Settings,
    Repeat,
    MessageCircle,
    Ticket,
    DollarSign,
    Flag,
    HelpCircle,
    BarChart3,
    LineChart,
    CalendarCheck,
    FileSignature

} from "lucide-react";

// Grouped into logical sections for the Ilmaivo pivot admin. `isTitle` rows
// render as non-clickable section headers in the vertical sidebar. Only the
// kept pivot pages remain (course-era tabs were removed).
export const MENU_ITEMS = [
    {
        key: "section-overview",
        label: "Overview",
        isTitle: true,
    },
    {
        key: "dashboard",
        label: "Dashboard",
        icon: Airplay,
        url: "/dashboard",
    },
    {
        key: "analytics",
        label: "Analytics",
        icon: BarChart3,
        url: "/analytics",
    },
    {
        key: "product-analytics",
        label: "Product Analytics",
        icon: LineChart,
        url: "/product-analytics",
    },

    {
        key: "section-money",
        label: "Money",
        isTitle: true,
    },
    {
        key: "User Subscriptions List",
        label: "User Subscriptions",
        icon: User,
        url: "/subscriptionListing"
    },
    {
        key: "Payout",
        label: "Payout",
        icon: DollarSign,
        url: "/payouts",
    },
    {
        key: "PayoutRuns",
        label: "Payout Runs",
        icon: DollarSign,
        url: "/payout-runs",
    },
    {
        key: "MoneyReconciliation",
        label: "Money Reconciliation",
        icon: DollarSign,
        url: "/money-reconciliation",
    },
    {
        key: "FeeTerms",
        label: "Fee Terms",
        icon: DollarSign,
        url: "/fee-terms",
    },
    {
        key: "ContractTerms",
        label: "Contract Terms",
        icon: DollarSign,
        url: "/contract-terms",
    },
    {
        key: "Transactions",
        label: "Transactions",
        icon: Repeat,
        url: "/transactions",
    },

    {
        key: "section-operations",
        label: "Operations",
        isTitle: true,
    },
    {
        key: "userManagement",
        label: "User Management",
        icon: User,
        url: "/user-management",
    },
    {
        key: "bookings",
        label: "Bookings",
        icon: CalendarCheck,
        url: "/bookings",
    },
    {
        key: "signed-contract-onboardings",
        label: "Contract Onboarding",
        icon: FileSignature,
        url: "/signed-contract-onboardings",
    },
    {
        key: "whatsapp-delivery",
        label: "WhatsApp Delivery",
        icon: MessageCircle,
        url: "/whatsapp-delivery",
    },
    {
        key: "rights-cases",
        label: "Rights Cases",
        icon: FileSignature,
        url: "/rights-cases",
    },
    {
        key: "report",
        label: "Reports",
        icon: Flag,
        url: "/report",
    },

    {
        key: "section-growth",
        label: "Growth",
        isTitle: true,
    },
    {
        key: "home-banners",
        label: "Home Banners",
        icon: ImageIcon,
        url: "/banner",
    },
    {
        key: "Communication Page",
        label: "Communication Page",
        icon: MessageCircle,
        url: "/communication-page",
    },

    {
        key: "section-support",
        label: "Support",
        isTitle: true,
    },
    {
        key: "Tickets",
        label: "Tickets",
        icon: Ticket,
        url: "/tickets",
    },
    {
        key: "feature",
        label: "FAQ",
        icon: HelpCircle,
        url: "/pages/faqs",
    },

    {
        key: "section-system",
        label: "System",
        isTitle: true,
    },
    {
        key: "setting",
        label: "Settings",
        icon: Settings,
        url: "/setting",
    },
];

export const HORIZONTAL_MENU_ITEM = [
    {
        key: "dashboard",
        label: "Dashboard",
        icon: "ri:airplay-line",
        url: "/dashboard",
    },
    {
        key: "admin",
        label: "Admin",
        icon: "ri:user-line",
        url: "/admin",
    },
    // Course-marketplace / template entries retired by the Ilmaivo pivot
    // (session booking). Hidden from the horizontal menu; page code preserved.
    // {
    //     key: "product",
    //     label: "Product",
    //     icon: "ri:package-line",
    //     url: "/product",
    // },
    // {
    //     key: "brand",
    //     label: "Brand",
    //     icon: "ri:box-line",
    //     url: "/brand",
    // },
    // {
    //     key: "category",
    //     label: "Category",
    //     icon: "ri:list-check-2",
    //     url: "/category", // list page
    // },
    // // dynamic route, hidden from static menu
    // {
    //     key: "category-details",
    //     label: "Category Details",
    //     icon: "ri:file-text-line",
    //     url: "/category/:id",
    // },
    {
        key: "banner",
        label: "Home Banners",
        icon: "ri:image-line",
        url: "/banner",
    },
    // Course-marketplace entries retired by the Ilmaivo pivot (hidden).
    // {
    //     key: "custom-goal",
    //     label: "Custom Goal",
    //     icon: "ri:target-line",
    //     url: "/custom-goal",
    // },
    // {
    //     key: "product-coupon",
    //     label: "Product Coupon",
    //     icon: "ri:ticket-2-line",
    //     url: "/product-coupon",
    // },
    // {
    //     key: "goal-category",
    //     label: "Goal Category",
    //     icon: "ri:flag-line",
    //     url: "/goal-category",
    // },
    {
        key: "feature",
        label: "FAQS",
        icon: "ri:star-line",
        url: "/pages/faqs",
    },
    // {
    //     key: "faq",
    //     label: "FAQ",
    //     icon: "ri:question-line",
    //     url: "/pages/faqs",
    // },
    // Course-marketplace entry retired by the Ilmaivo pivot (hidden).
    // {
    //     key: "spend-tracker",
    //     label: "Spend Tracker",
    //     icon: "ri:trending-up-line",
    //     url: "/spend-tracker",
    // },
];
